export default function minTranslate() {
  return -this.snapGrid[0];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/esm/components/core/translate/minTranslate.js
// module id = null
// module chunks = 